import { ContactListInfo, ContactListPerson } from "@/pages/Private/pages/Contacts/schema/contacts";

import { ListPersonOtherLists } from "../schema/list";

export interface LeadLocationLists {
	listPersons: ContactListPerson[];
	lists: ContactListInfo[];
}

/**
 * Adapt a list lead's `otherLists` memberships into the shape the `ContactLeadLocation` widget
 * consumes (`listPersons` + `lists`). `otherLists` already excludes the list currently being
 * viewed and only contains added memberships (both enforced by the backend), so the widget shows
 * only the OTHER lists the lead belongs to.
 *
 * `ContactListPerson.updatedAt` is required by the type but unused by the widget; we fill it from
 * the other list's `updatedAt` to satisfy the type. The list id doubles as the membership `id`
 * (used only as a React key here).
 */
export const toLeadLocationLists = (otherLists?: ListPersonOtherLists[]): LeadLocationLists => {
	const listPersons: ContactListPerson[] = [];
	const lists: ContactListInfo[] = [];
	const seen = new Set<number>();

	for (const other of otherLists ?? []) {
		const id = other.list?.id;

		if (typeof id !== "number" || seen.has(id)) {
			continue;
		}

		seen.add(id);

		listPersons.push({
			id,
			listId: id,
			assignStatus: other.assignStatus,
			updatedAt:
				other.list.updatedAt instanceof Date
					? other.list.updatedAt.toISOString()
					: new Date().toISOString(),
		});
		lists.push({ id, name: other.list.name ?? "" });
	}

	return { listPersons, lists };
};
